import clsx from "clsx"
import React from "react"
import { IconProps } from "."

export default function TimeLine({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M12 21C16.9707 21 21 16.9707 21 12C21 7.0293 16.9707 3 12 3C7.0293 3 3 7.0293 3 12C3 16.9707 7.0293 21 12 21ZM12 19.2C10.0904 19.2 8.25909 18.4414 6.90883 17.0912C5.55857 15.7409 4.8 13.9096 4.8 12C4.8 10.0904 5.55857 8.25909 6.90883 6.90883C8.25909 5.55857 10.0904 4.8 12 4.8C13.9096 4.8 15.7409 5.55857 17.0912 6.90883C18.4414 8.25909 19.2 10.0904 19.2 12C19.2 13.9096 18.4414 15.7409 17.0912 17.0912C15.7409 18.4414 13.9096 19.2 12 19.2ZM11.1 12H7.5V13.8H12.9V7.5H11.1V12Z"
        fill="currentColor"
      />
    </svg>
  )
}
